function formatShippingMoney(cents, currencyCode) {
  return new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0
  }).format(cents / 100);
}

function updateShippingEstimate(cart) {
  var container = document.getElementById('shipping-estimate');
  if (!container) return;
  var shippingThreshold = parseInt(container.dataset.threshold, 10);
  var baseShipping = parseInt(container.dataset.baseShipping, 10);
  var currencyCode = container.dataset.currency;

  var subtotal = cart.items_subtotal_price || cart.total_price;
  var shipping = subtotal >= shippingThreshold ? 0 : baseShipping;
  var amountLeft = subtotal >= shippingThreshold ? 0 : shippingThreshold - subtotal;
  var estTotal = subtotal + shipping;

  var shipVal = document.getElementById('shipping-estimate-value');
  if (shipVal) shipVal.textContent = formatShippingMoney(shipping, currencyCode);


  var progress = document.querySelector('.cart-shippingThreshold__progress');
  if (progress)
    progress.style.width = Math.min(100, Math.round((subtotal * 100) / shippingThreshold)) + '%';

  var numOuter = document.querySelector('.cart-shipping__numOuter');
  var success = document.querySelector('.cart-shipping__success');
  if (amountLeft <= 0) {
    if (numOuter) numOuter.classList.add('hidden');
    if (success) success.classList.remove('hidden');
  } else {
    if (numOuter) {
      numOuter.classList.remove('hidden');
      var num = numOuter.querySelector('.cart-shipping__num');
      if (num) num.textContent = formatShippingMoney(amountLeft, currencyCode);
    }
    if (success) success.classList.add('hidden');
  }

  document
    .querySelectorAll('#main-cart-footer .totals__total-value')
    .forEach(function (el) {
      el.textContent = formatShippingMoney(estTotal, currencyCode);
    });
}


function fetchCartAndUpdate() {
  fetch('/cart.js')
    .then(function (r) {
      return r.json();
    })
    .then(updateShippingEstimate);
}


function initShippingEstimate() {
  fetchCartAndUpdate();

  document
    .querySelectorAll('form[action="/cart"]')
    .forEach(function (form) {
      form.addEventListener('change', function () {
        setTimeout(fetchCartAndUpdate, 350);
      });
    });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      updateShippingEstimate(event.cartData);
    });
  }

  var cartForms = document.querySelectorAll(
    'form[action="/cart"], form.cart, cart-items form'
  );
  cartForms.forEach(function (form) {
    form.addEventListener('change', function () {
      setTimeout(fetchCartAndUpdate, 350);
    });
  });

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShippingEstimate);
} else {
  initShippingEstimate();
}
